import { WebPlugin } from '@capacitor/core';

import type { MPayWeChatParams, WechatHKPlugin } from './definitions';

export class WechatHKWeb extends WebPlugin implements WechatHKPlugin {
    async echo(options: { value: string }): Promise<{ value: string }> {
        console.log('ECHO', options);
        return options;
    }

    async makePaymentRequest(options: { options: MPayWeChatParams }): Promise<any> {
        console.warn('web not implemented', options);
        return ({} as any);
    }
}
